<template>
  <div class="IndexApp" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <headComponent :idx='1' :lm='imgs'></headComponent>
    <div class="banner">
      <div class="con"><!--:style="'background-image: url('+baseUrl+setAdvert.images+');'"
        <video width="100%" class="banner-video" id="banner-video1" muted="" autoplay="autoplay"  loop="">
          <source :src="videoSrc" type="video/mp4">
        </video>-->
        <videoPlayer class="video-player vjs-custom-skin" ref="videoPlayer" :playsinline="true" :options="playerOptions"></videoPlayer>
        <div class="txt">
          <h2 class="tit">{{setAdvert.title}}</h2>
          <div class="tips">{{setAdvert.brief}}</div>
          <div class="bot">
            <a href="javascript:;"  @click="$router.push('about')" class="btn btn-1" tabindex="0">了解我们　&gt;</a>
          </div>
        </div>
      </div>
      <!--<a class="btn-down" :style="'background: url('+downBtn+') no-repeat center;'"></a>-->
    </div>
    <div class="row-a2">
      <div class="wp">
        <div class="g-t1">
          <h2 class="tit">核心产品</h2>
        </div>

        <div class="product">
          <ul class="left">
            <li @click="clickCate(i)" v-if="i<4" :class="inx == i ? 'on' : ''" v-for="(item,i) in setProduct">
              <a href="javascript:;"><font>{{item.title}}</font>
                <i class="el-icon-caret-right"></i>
              </a>
            </li>
          </ul>

          <div class="right">
            <div class="top" v-if="setProduct[inx].jsonStr != null">
              <div class="procon">
                <h1>{{setProduct[inx].jsonStr[proInx].title}}</h1>
                <h2>{{setProduct[inx].title}}</h2>
                <p>{{setProduct[inx].jsonStr[proInx].brief}}</p>
                <a @click="$router.push('detail?id='+setProduct[inx].jsonStr[proInx].id)">查看详情<i class="el-icon-caret-right"></i></a>
                <dl>
                  <dd v-for="(item,i) in setProduct[inx].jsonStr" @click="proClick(i)" :class="i == proInx ? 'on' : ''" v-if="i<4">
                    <div class="pic"><img :src="baseUrl+item.images" alt=""></div>
                    <h3>{{item.title}}</h3>
                  </dd>
                </dl>
              </div>
              <div class="proImage">
                <img class="probg" src="~assets/images/probg2.png">
                <img class="protrue" :src="baseUrl+setProduct[inx].jsonStr[proInx].images" >
              </div>
            </div>
          </div>
        </div>

        <div class="mobileProduct">
          <ul class="left">
            <li @click="clickCate(i)" v-if="i<4" :class="inx == i ? 'on' : ''" v-for="(item,i) in setProduct">
              <a href="javascript:;"><font>{{item.title}}</font></a>
            </li>
          </ul>

          <div class="right">
            <div class="top" v-if="setProduct[inx].jsonStr != null" v-for="(item,i) in setProduct[inx].jsonStr">
              <div class="procon">
                <h1>{{item.title}}</h1>
                <h2>{{setProduct[inx].title}}</h2>
                <p>{{item.brief}}</p>
                <a @click="$router.push('detail?id='+setProduct[inx].jsonStr[proInx].id)">查看详情<i class="el-icon-caret-right"></i></a>
              </div>
              <div class="proImage">
                <img class="protrue" :src="baseUrl+item.images" >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row-a3">
      <div class="m-slider1">
        <div class="slide-for">
          <div class="slider">
            <div class="item" :style="'background-image: url('+baseUrl+tradeDetail.images+');'">
              <div class="txt">
                <h3>应用场景——{{tradeDetail.title}}</h3>
                <div class="desc"><p>{{tradeDetail.brief}}</p></div>
                <!--<a href="javascript:;" @click="$router.push('trade?id='+tradeDetail.id)" class="more">查看详情    &gt;</a>-->
              </div>
            </div>
          </div>
        </div>
        <div class="slide-nav">
          <div class="slick-list">
            <ul>
              <li :class="i == tinx ? 'on' : ''" v-for="(item,i) in setTrade"  @click="clickTrade(i)">
                <div class="tit">
                  <span>应用场景</span>
                  <h3>{{item.title}}</h3>
                </div>
                <div class="ico el-icon-tickets"></div>
              </li>
            </ul>
          </div>
        </div>
        <div class="slide-nav mobileNav">
          <div class="slick-list">
            <ul>
              <li :class="i == tinx ? 'on' : ''" v-for="(item,i) in setTrade"  @click="clickTrade(i)">
                <div class="tit">
                  <h3>{{item.title}}</h3>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="row-a4">
      <h2>关于我们</h2>
    </div>
    <div class="us" :style="'background:url('+usbg+') no-repeat'">
      <div class="uscon">
        <img src="~assets/images/us.jpg">
        <div class="usright">
          <h2>广西沧龙科技有限公司</h2>
          <p>沧龙科技是一家专注于海洋智能装备研制开发、生产制造及销售服务的创新型科技企业。公司于2024年4月成立，同年12月落户钦州市钦南区，在南宁设有研发中心，在山东青岛、广东深圳设有联合研发中心；2025年7月，公司生产基地在钦州金窝工业园投产，目前是我区首家且唯一一家水面水下机器人生产制造基地。</p>
          <p>公司掌握全系列液压作业型ROV、电动 ROV 研发制造技术，以及AUV技术、水面无人艇（USV）、基于虚拟现实/人工智能（VR/AI）的水下作业辅助系统、超长距离无人遥控水下作业平台技术。</p>
          <p>获得中央引导地方科技发展专项资金支持，获得第十四届中国创新创业大赛广西赛区钦州选拔赛暨第十二届钦州市科技创业大赛决赛二等奖、广西赛区暨2025年广西创新创业大赛高端装备、新材料产业复赛第四名。</p>
          <a @click="$router.push('about')">联系我们<i class="el-icon-arrow-right"></i></a>
        </div>
        <div style="clear:both"></div>
      </div>
    </div>
    <!--<div class="row-a4">
      <h2>应用案例</h2>
      <ul>
        <li v-for="(item,i) in setCase">
          <a href="javascript:;" @click="$router.push('tradedetail?id='+item.id)">
            <img :src="baseUrl+item.images" >
            <h1>{{item.tradeTitle}}</h1>
            <p style="color: #333;font-size:16px;-webkit-line-clamp: 1;">{{item.title}}</p>
            <p>{{item.content.replace(/<[^>]+>/gim,"")}}</p>
          </a>
        </li>        
      </ul>
    </div>-->


    <div class="row-a4" style="padding-bottom:3.5vw">
      <h2>新闻中心</h2>
      <div class="newLeft">
        <i class="el-icon-arrow-left" @click="prev"></i>
        <div v-for="(item,i) in setNewsIndex" v-if="newInx == i"  @click="$router.push('newsdetail?id='+item.id)">
          <img :src="baseUrl+item.image">
          <div class="txt">
            <h3>{{item.title}}</h3>
            <p>{{item.content.replace(/<[^>]+>/gim,"")}}</p>
            <p>发布时间：{{item.createtime}}</p>
          </div>
        </div>
        <i class="el-icon-arrow-right" @click="next"></i>
      </div>
      <div class="newRight">
        <dl>
          <dd :class="newInx == i ? 'curt' : ''" v-for="(item,i) in setNewsIndex" @click="$router.push('newsdetail?id='+item.id)">
            <h3>{{item.title}}</h3>
            <p>{{item.content.replace(/<[^>]+>/gim,"")}}</p>
            <p>发布时间：{{item.createtime}}</p>
          </dd>
        </dl>
      </div>
      <div style="clear:both"></div>
    </div>

    <footComponent></footComponent>
  </div>
</template>
<script>
  import { videoPlayer } from 'vue-video-player'
  import '../../../assets/video.js/dist/video-js.css'
  import $ from 'jquery'
  export default {
    data() {
      return {
        curHeight:0,
        fullscreenLoading: false,
        baseUrl:'',
        downBtn:require('../../../assets/images/i-02.png'),
        pro:require('../../../assets/images/probg.jpg'),
        usbg:require('../../../assets/images/usbg.jpg'),
        videoSrc:require('../../../assets/video/mv.mp4'),
        setAdvert:[],
        setProduct:[],
        inx:0,
        proInx:0,
        setTrade:[],
        tradeDetail:[],
        tinx:0,
        setCase:[],
        imgs:0,
        newInx:0,
        setNewsIndex:[],
        playerOptions: {
           playbackRates: [0.5, 1.0, 1.5, 2.0], // 可选的播放速度
           autoplay: true, // 如果为true,浏览器准备好时开始回放。
           muted: true, // 默认情况下将会消除任何音频。
           loop: true, // 是否视频一结束就重新开始。
           preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
           language: 'zh-CN',
           aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
           fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
           sources: [{
            type: "video/mp4", // 类型
            src: require('../../../assets/video/mv.mp4') // url地址
           }],
           poster: require('../../../assets/video/Cover0.jpg'), // 封面地址
           notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
           controlBar: {
              timeDivider: true, // 当前时间和持续时间的分隔符
              durationDisplay: false, // 显示持续时间
              remainingTimeDisplay: true, // 是否显示剩余时间功能
              fullscreenToggle: true // 是否显示全屏按钮
           }
        },
      };
    },
    beforeMount() {
      this.baseUrl = this.$fileurl;
    },
    mounted() {
      this.beforeMount();
      this.getAdvert();
      this.getProduct();
      this.getTrade();
      //this.getCase();
      this.getNewsIndex();
      var that = this;
      $(document).scroll(function() {
        var scroH = $(document).scrollTop();
        if(scroH > 20){
          $('.IndexApp .header').css('background','#fff');
          $('.IndexApp .header .nav li a').css('color','#333');
          $('.IndexApp .header').addClass('t');
          that.imgs = 1;
        }else{
          $('.IndexApp .header').css('background','none');
          $('.IndexApp .header .nav li a').css('color','#fff');
          $('.IndexApp .header').removeClass('t');
          that.imgs = 0;
        }
      })
    },
    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },
      getAdvert:function(){
        var that = this;
        that.fullscreenLoading = true;
        var id = that.$route.query.id
        $.ajax({
          type:'post',
          url:that.$host+'home/index/getAdvert',
          data:{
            id:id
          },
          dataType:'json',
          success:function(data){
            that.setAdvert = data.data;
            that.fullscreenLoading = false;
          }
        })
      },
      clickCate:function(inx){
        this.inx = inx;
        this.proInx = 0;
      },
      proClick:function(inx){
        this.proInx = inx;
        $('.protrue').css('animation','productAM2 1s cubic-bezier(0.25, 1, 0.5, 1) forwards')
      },
      getProduct:function(){
        var that = this;
        that.fullscreenLoading = true;
        $.ajax({
          type:'post',
          url:that.$host+'home/index/product',
          dataType:'json',
          success:function(data){
            that.setProduct = data.data;
            that.inx = 0;
            that.fullscreenLoading = false;
          }
        })
      },
      clickTrade:function(i){
        var that = this;
        that.tinx = i;
        var arr = {
          'id':that.setTrade[i].id,
          'title':that.setTrade[i].title,
          'brief':that.setTrade[i].brief,
          'images':that.setTrade[i].images
        };
        that.tradeDetail = arr;
      },
      getTrade:function(){
        var that = this;
        that.fullscreenLoading = true;
        $.ajax({
          type:'post',
          url:that.$host+'home/index/trade',
          dataType:'json',
          success:function(data){
            that.setTrade = data.data;
            that.tinx = 0;
            var len = data.data.length;
            for(var i=0;i<len;i++){
              if(that.tinx == i){
                var arr = {
                  'id':data.data[i].id,
                  'title':data.data[i].title,
                  'brief':data.data[i].brief,
                  'images':data.data[i].images
                };
                that.tradeDetail = arr;
              }
            }
            that.fullscreenLoading = false;
          }
        })
      },
      getCase:function(){
        var that = this;
        that.fullscreenLoading = true;
        $.ajax({
          type:'post',
          url:that.$host+'home/index/indexCase',
          dataType:'json',
          success:function(data){
            that.setCase = data.data;
            that.fullscreenLoading = false;
          }
        })
      },
      getNewsIndex:function(){
        var that = this;
        that.fullscreenLoading = true;
        $.ajax({
          type:'post',
          url:that.$host+'home/index/newsIndex',
          dataType:'json',
          success:function(data){
            that.setNewsIndex = data.data;


            that.fullscreenLoading = false;
          }
        })
      },
      next:function(){
        var newInx = this.newInx;
        var len = this.setNewsIndex.length;
        if(newInx+1 > len-1){
          this.newInx = 0;
        }else{
          this.newInx = newInx+1
        }
      },
      prev:function(){
        var newInx = this.newInx;
        var len = this.setNewsIndex.length;
        if(newInx - 1 < 0){
          this.newInx = len-1;
        }else{
          this.newInx = newInx - 1
        }
      },
    },
    components: {
      videoPlayer
    },
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .IndexApp .el-message-box{
    width:30%
  }
  .IndexApp{
    width:100%;
    margin:0 auto;
  }
  .IndexApp .header{
    background:none
  }
  .IndexApp .header .nav li a{
    color:#fff
  }
  .IndexApp .header .nav li.on a::after,.IndexApp .header .nav li:hover a:after{
    background:#fff;
    border-color:#fff
  }
  .IndexApp .header.t .nav li.on a::after,.IndexApp .header.t .nav li:hover a:after{
    background:#01248C;
    border-color:#01248C;
  }
  .IndexApp .header.t .nav li.on a{
    color:#01248C !important;
  }
  .IndexApp .banner{
    width:100%;
    position: relative;
  }
  .IndexApp .banner .con{
    display:block;
    background-size: cover;
    outline: 0;
    position: relative;
    background-position: center center;
    background-repeat: no-repeat;
  }
  .IndexApp .banner .txt{
    position: absolute;
    left: 0;
    right: 0;
    top: 0%;
    text-align: center;
    color: #fff;
    background:rgba(255,255,255,0);
    padding-top:23%

  }
  .IndexApp .banner .tit{
    font-size: 60px;
    font-weight: normal;
    margin-bottom: 12px;
    opacity:1;
    transition:all 1.5s ease-out;
  }
  .IndexApp .banner .tips{
    font-size: 16px;
    margin-bottom: 42px;
    opacity:1;
    transition:all 2s ease-out;
  }
  .IndexApp .banner .bot{
    font-size: 0;
    opacity:1;
    transition:all 2.5s ease-out;
  }
  .IndexApp .banner .bot .btn {
    width: 9.375vw;
    height: 2.604vw;
    line-height: 2.5vw;
    font-size: 0.833vw;
    border-radius: 1.302vw;
    margin: 0 0.937vw;
    border: 1px solid #fff;
    display: inline-block;
    color: #fff;
    text-decoration: none;
  }
  .IndexApp .banner .btn-down{
    position: absolute;
    bottom: 56px;
    left: 50%;
    width: 20px;
    height: 70px;
    z-index: 3;
    background-size: 100% auto;
    animation: downico3 2s linear infinite;
  }
  .IndexApp .row-a2 {
    padding: 3.75vw 0 3.697vw;
  }
  .IndexApp .wp{
    max-width: 1600px;
    margin: 0 auto;

  }
  .IndexApp .wp .g-t1{
    text-align: center;
  }
  .IndexApp .wp .g-t1 .tit {
    font-size: 2.187vw;
    font-weight: normal;
    color:#333
  }
  .IndexApp .wp .product{
    padding-top:2vw
  }
  .IndexApp .wp .mobileProduct{
    display:none;
  }
  .IndexApp .wp .product:after{
    clear: both;
    content: '.';
    display: block;
    width: 0;
    height: 0;
    visibility: hidden;
  }
  .IndexApp .wp .product .left{
    width:18vw;
    background:#FAFAFA;
    float:left;
    padding:12px 0
  }
  .IndexApp .wp .product .left li{
    width:85%;
    margin:0 auto;
    padding:20px 0
  }
  .IndexApp .wp .product .left li a{
    color:#333;
    font-size:17px;
    display:block;
  }
  .IndexApp .wp .product .left li a font{
    float:left;
    width:85%
  }
  .IndexApp .wp .product .left li a i{
    float:right;
    padding-top:3px
  }
  .IndexApp .wp .product .left li.on a{
    font-weight:bold;
    color:#01248C
  }
  .IndexApp .wp .product .left li a:hover{
    font-weight:bold;
    color:#01248C
  }
  .IndexApp .wp .product .right{
    float:left;
    width:calc(100% - 18vw);
    background:#fff;
  }
  .IndexApp .wp .product .right .top{
    height:400px;
    padding:0 15px 0 50px
  }
  .IndexApp .wp .product .right .top .procon{
    float:left;
    width:calc(100% - 20vw)
  }
  .IndexApp .wp .product .right .top .procon h1{
    font-size:28px;
    line-height: 1.4;
  }
  .IndexApp .wp .product .right .top .procon h2{
    font-size:16px;
    line-height: 1.4;
    margin-top: 15px;
  }
  .IndexApp .wp .product .right .top .procon p{
    width: 90%;
    font-size: 15px;
    color: #666;
    margin-top: 16px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
    text-overflow: ellipsis;
    min-height: 60px;
    text-align: justify;
    line-height: 1.4;
  }
  .IndexApp .wp .product .right .top .procon dl{
    display: flex;
    gap: 0 20px;
    margin: 50px 0 0 0;
    width:90%;
  }
  .IndexApp .wp .product .right .top .procon dl dd{
    width: calc(100% / 8 * 2);
    cursor: pointer;
    background:#FAFAFA;
    padding-bottom:12px
  }
  .IndexApp .wp .product .right .top .procon dl dd .pic img{
    display:block;
    width:95%;
    margin:10px auto;

    object-fit: cover;
    width:92%;
    height:100px
  }
  .IndexApp .wp .product .right .top .procon dl dd h3{
    text-align:center;
    font-size:15px;
    font-weight:normal;
    padding:0 2px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
  }
  .IndexApp .wp .product .right .top .procon dl dd.on h3,.IndexApp .wp .product .right .top .procon dl dd:hover h3{
    color: #01248C;
  }
  .IndexApp .wp .product .right .top .procon a{
    font-size: 15px;
    color: #01248C;
    margin-top: 30px;
    display: flex;
    align-items: center;
    position: relative;
    cursor: pointer;
  }
  .IndexApp .wp .product .right .top .proImage{
    float:left;
    width:20vw;
    fong-size:0;
    position: relative;
  }
  .IndexApp .wp .product .right .top .proImage .probg{
    width:100%;
    max-height:420px
  }
  .IndexApp .wp .product .right .top .proImage .protrue{
    position: absolute;
    transform: translate(-50%,-50%);
    width:100%;
    top: 50%;
    left:50%;
    animation: productAM2 1s cubic-bezier(0.25, 1, 0.5, 1) forwards;
    z-index:1
  }

  .IndexApp .row-a3 .m-slider1{
    position: relative;
  }
  .IndexApp .row-a3 .m-slider1 .slick-slider{
    position: relative;
    display: block;
    box-sizing: border-box;
    user-select: none;
    touch-action: pan-y;
  }
  .IndexApp .row-a3 .m-slider1 .slick-slider .slick-list{
    position: relative;
    display: block;
    overflow: hidden;
    margin: 0;
    padding: 0;
    transform: translate3d(0, 0, 0);
  }
  .IndexApp .row-a3 .m-slider1 .slide-for .item{
    width: 100%;
    position: relative;
    left: 0px;
    top: 0px;
    z-index: 3;
    opacity: 1;
    height: 50.52vw;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  }
  .IndexApp .row-a3 .m-slider1 .slide-for .txt{
    position: absolute;
    color: #fff;
    left: 8.333vw;
    top: 12.5vw;
    width:calc(100% - 8.333vw)
  }
  .IndexApp .row-a3 .m-slider1 .slide-for h3{
    font-weight: normal;
    font-size: 2.187vw;
    margin-bottom: 1.875vw;
  }
  .IndexApp .row-a3 .m-slider1 .slide-for .desc{
    font-size: 0.937vw;
    margin-bottom: 1.718vw;
    line-height: 1.72;
    width:50%;
  }
  .IndexApp .row-a3 .m-slider1 .slide-for .more {
    display: inline-block;
    padding-bottom: 5px;
    font-size: 12px;
    border-bottom: 1px solid #fff;
    color: #fff;
  }
  .IndexApp .row-a3 .m-slider1 .slide-nav{
    position: absolute;
    left: 8.333vw;
    right: 8.333vw;
    bottom: 3.125vw;
    z-index:9
  }
  .IndexApp .row-a3 .m-slider1 .mobileNav{
    display:none;
  }
  .IndexApp .row-a3 .m-slider1 .slide-nav .slick-list{
    position: relative;
    display: block;
    overflow: hidden;
    margin: 0;
    padding: 0;
    transform: translate3d(0, 0, 0);
  }
  .IndexApp .row-a3 .m-slider1 .slide-nav .slick-list ul{
    width:3344px;
    position: relative;
    top: 0;
    left: 0;
    display: block;
    transform: translate3d(0, 0, 0);
  }
  .IndexApp .row-a3 .m-slider1 .slide-nav .slick-list ul:after{

  }
  .IndexApp .row-a3 .m-slider1 .slide-nav .slick-list ul li{
    float:left;
    background:rgba(255,255,255,0.8);
    height: 9vw;
    width: 9.8vw;
    cursor: pointer;
    margin: 1.302vw 0.208vw;
    position: relative;
  }
  .IndexApp .row-a3 .m-slider1 .slide-nav .slick-list ul li.on{
    background-color: #3A66A6;
    margin-top: 0;
    height: 10.31vw;
  }
  .IndexApp .row-a3 .m-slider1 .slide-nav .slick-list ul li .tit{
    position: absolute;
    top: 1.406vw;
    left: 1.145vw;
    padding-bottom: 0.677vw;
  }
  .IndexApp .row-a3 .m-slider1 .slide-nav .slick-list ul li .tit::after {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    display: block;
    width: 1.302vw;
    height: 0.104vw;
    background-color: #535353;
  }
  .IndexApp .row-a3 .m-slider1 .slide-nav .slick-list ul li.on .tit::after{
    background-color: #F53E40;
  }
  .IndexApp .row-a3 .m-slider1 .slide-nav .slick-list ul li .tit span {
    color: #888;
    display: block;
    font-size: 0.8vw;
    margin-bottom: 0.156vw;
  }
  .IndexApp .row-a3 .m-slider1 .slide-nav .slick-list ul li .tit h3 {
    font-size: 1.2vw;
    font-weight: normal;
    color:#333
  }
  .IndexApp .row-a3 .m-slider1 .slide-nav .slick-list ul li.on .tit span,.IndexApp .row-a3 .m-slider1 .slide-nav .slick-list ul li.on .tit h3{
    color:#fff
  }
  .IndexApp .row-a3 .m-slider1 .slide-nav .slick-list ul li .ico{
    position: absolute;
    right: 0.520vw;
    bottom: 0.520vw;
    width: 2.7vw;
    height: 2.7vw;
    font-size:2.3vw;
    color:#999
  }
  .IndexApp .row-a3 .m-slider1 .slide-nav .slick-list ul li.on .ico{
    color:#fff
  }

  .IndexApp .row-a4{
    max-width: 1600px;
    margin: 0 auto;
    padding: 3.75vw 0 0 3.697vw;
  }
  .IndexApp .row-a4 h2{
    font-size: 2.187vw;
    font-weight: normal;
    color: #333;
    text-align: center;
    margin-bottom:3.697vw
  }
  .IndexApp .row-a4 ul:after,.IndexApp .wp .product .left li a:after{
    clear: both;
    content: '.';
    display: block;
    width: 0;
    height: 0;
    visibility: hidden;
  }
  .IndexApp .row-a4 ul li{
    width:25%;
    float:left;
    margin-bottom:15px
  }
  .IndexApp .row-a4 ul li a{
    display:block;
    background:#fff;
    box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.2);
    border-radius: 8px;
    margin: 0 0.433vw;
    padding-bottom:12px;
  }
  .IndexApp .row-a4 ul li a:hover{
    opacity: .9;
  }
  .IndexApp .row-a4 ul li img{
    width:100%;
    height:320px;
    object-fit: cover;
    border-radius: 8px 8px 0 0;
  }
  .IndexApp .row-a4 ul li h1{
    font-size:18px;
    color:#4470AF;
    padding:8px 8px
  }
  .IndexApp .row-a4 ul li p{
    padding:0px 8px 0 8px;
    margin-bottom:12px;
    font-size:14px;
    color:#888;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
  }

  .IndexApp .row-a4 .newLeft{
    float:left;
    width:35%;
    height: 20.04vw;
    background:#fff;
    position: relative;
    font-size:0;
    cursor: pointer;
  }
  .IndexApp .row-a4 .newLeft img{
    width:100%;
    object-fit: cover;
    display:block;
    height: 20.04vw;
  }
  .IndexApp .row-a4 .newLeft .txt{
    position: absolute;
    bottom:0;
    left:0;
    background:rgba(0,0,0,0.5);
    width:calc(100% - 24px);
    padding:10px 12px 2px 12px
  }
  .IndexApp .row-a4 .newLeft .txt h3{
    color:#fff;
    font-size:15px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
    margin-bottom:8px
  }
  .IndexApp .row-a4 .newLeft .txt p{
    color:#fff;
    font-size:12px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    line-height:22px;
    margin-bottom:4px
  }
  .IndexApp .row-a4 .newLeft .el-icon-arrow-left{
    position: absolute;
    background:rgba(255,255,255,0.8);
    width:20px;
    height:20px;
    font-size:16px;
    color:#333;
    border-radius: 50%;
    text-align:center;
    line-height:20px;
    left:12px;
    top:50%;
    z-index:2;
    transform: translateY(-50%);
  }
  .IndexApp .row-a4 .newLeft .el-icon-arrow-right{
    position: absolute;
    background:rgba(255,255,255,0.8);
    width:20px;
    height:20px;
    font-size:16px;
    color:#333;
    border-radius: 50%;
    text-align:center;
    line-height:20px;
    right:12px;
    top:50%;
    z-index:2;
    transform: translateY(-50%);
  }
  .IndexApp .row-a4 .newRight{
    float:left;
    width:60%;
    background:#fff;
    height: 20.04vw;
    overflow: hidden;
  }
  .IndexApp .row-a4 .newRight dl{
    display:block;
    margin-left:12px
  }
  .IndexApp .row-a4 .newRight dl dd{
    border-bottom:solid 1px #eee;
    padding: 11px 11px;
    cursor: pointer;
  }
  .IndexApp .row-a4 .newRight dl dd.curt,.IndexApp .row-a4 .newRight dl dd:hover{
    background:#eee
  }
  .IndexApp .row-a4 .newRight dl dd:last-child{
    border-bottom:none;
  }
  .IndexApp .row-a4 .newRight dl dd h3{
    font-size:16px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
    margin-bottom:10px
  }
  .IndexApp .row-a4 .newRight dl dd p{
    color:#888;
    font-size:14px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    line-height:21px;
    margin-bottom:8px
  }

  .IndexApp .us{
    width:100%;
    background-size: cover;
  }
  .IndexApp .us .uscon{
    max-width:1600px;
    margin:0 auto;
    padding:112px 0 94px 0
  }
  .IndexApp .us .uscon img{
    width:28%;
    font-size:0;
    float:left
  }
  .IndexApp .us .uscon .usright{
    float:left;
    width:68%;
    margin-left:2%
  }
  .IndexApp .us .uscon .usright h2{
    color:#fff;
    font-size:24px;
    margin-bottom:24px
  }
  .IndexApp .us .uscon .usright p{
    color:#fff;
    line-height:32px;
    text-align: justify;
    font-size:15px;
  }
  .IndexApp .us .uscon .usright a{
    font-size:15px;
    color:#fff;
    cursor: pointer;
    padding-top:50px;
    display:block;
    width:90px
  }
  @media only screen and (max-width: 1199px) {
    .IndexApp .header{
      height:60px;
    }
    .IndexApp .header .logo img{
      height:25px;
      margin:17.5px 12px 0 12px
    }
    .IndexApp .header .nav{
      text-align:right
    }
    .IndexApp .header .nav li{
      margin:0 1.8vw
    }
    .IndexApp .header .nav .close{
      display:none
    }
    .IndexApp .header .nav a{
      line-height:60px;
      font-size:14px
    }
    .nav li:hover .tradeHead,.header li:hover .productHead{
      display:none !important;
    }
    .IndexApp .banner{
    }
    .IndexApp .banner .tit{
      font-size:26px
    }
    .IndexApp .banner .tips{
      font-size:12px;
      margin-bottom:20px
    }
    .IndexApp .banner .bot .btn{
      font-size:12px;
      width:100px;
      height:32px;
      line-height:32px;
    }
    .IndexApp .banner .btn-down{
      bottom: 25px;
    }

    .IndexApp .product{
      display:none;
    }

    .IndexApp .wp .g-t1 .tit{
      color:#000;
      font-size:26px;
      font-weight:bold
    }
    .IndexApp .mobileProduct{
      display:block !important;
    }
    .IndexApp .mobileProduct .left{
      display: flex;
      flex-wrap: nowrap;
      justify-content: space-between;
      margin: 0 auto;
      padding:30px 0;
      width:94%
    }
    .IndexApp .mobileProduct .left li{
      width:25%;
    }
    .IndexApp .mobileProduct .left li a{
      color:#333;
      font-size:15px;
      width:92%;
      text-align:center;
      line-height:24px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
    }
    .IndexApp .mobileProduct .left li.on a{
      font-weight: bold;
      color: #01248C;
    }
    .IndexApp .mobileProduct .right .top{
      width:94%;
      margin:0 auto 12px auto;
      background:#FAFAFA;
      border-radius:6px;
    }
    .IndexApp .mobileProduct .right .top .procon{
      padding:15px
    }
    .IndexApp .mobileProduct .right .top .procon h1{
      font-size:18px;
      color:#000;
      padding-bottom:8px
    }
    .IndexApp .mobileProduct .right .top .procon h2{
      font-size:16px;
      font-weight:500;
      padding-bottom:8px
    }
    .IndexApp .mobileProduct .right .top .procon p{
      font-size:15px;
      color:#666;
      line-height:24px;
      text-align: justify;
    }
    .IndexApp .mobileProduct .right .top .procon a{
      font-size: 15px;
      color: #01248C;
      margin-top: 15px;
      display: flex;
      align-items: center;
      position: relative;
      cursor: pointer;
    }
    .IndexApp .mobileProduct .right .top .proImage{
      padding:0 15px 15px 15px
    }
    .IndexApp .mobileProduct .right .top .proImage img{
      display:block;
      width:100%;
      margin:0 auto;
    }

    .IndexApp .row-a4 h2{
      color: #000;
      font-size: 26px;
      font-weight: bold;
    }
    .IndexApp .wp .g-t1 .tab li a{
      font-size:14px;
      width:auto;
      height:32px;
      line-height:32px;
      padding:0 8px;
      border-radius:32px;
      margin: 0 3px;
      font-size:12px
    }
    .IndexApp .wp .m-list2 .lab,.IndexApp .wp .m-list2 .tips,.IndexApp .wp .m-list2 .more{
      font-size:12px
    }
    .IndexApp .wp .m-list2 h3{
      font-size:15px
    }
    .IndexApp .wp .m-list2 .pic img{
      max-width:100%
    }
    .IndexApp .wp .g-btn1{
      font-size:14px;
      width:100px;
      height:32px;
      line-height:32px;
      border-radius:32px;
    }
    .IndexApp .wp .m-list2 .con{
      height:160px;
      margin:0 1.5vw
    }
    .IndexApp .row-a4 ul{

      flex-wrap: wrap;
    }
    .IndexApp .row-a4 ul li{
      width:50%;
      margin-bottom:12px;
    }
    .IndexApp .row-a4 ul li a{
      margin: 0 1.5vw;
    }
    .IndexApp .row-a4 ul li img{
      height:200px
    }
    .IndexApp .row-a3 .m-slider1 .slide-for .item{
      height:70vw
    }
    .IndexApp .row-a3 .m-slider1 .slide-for .txt{
      top:15px
    }
    .IndexApp .row-a3 .m-slider1 .slide-for h3{
      font-size:18px
    }
    .IndexApp .row-a3 .m-slider1 .slide-for .desc{
      font-size:14px;
      width:85%;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 5;
      overflow: hidden;
    }
    .IndexApp .row-a3 .m-slider1 .slide-nav{
      bottom:0px;
      display:none;
    }
    .IndexApp .row-a3 .m-slider1 .mobileNav{
      display:block;
      left:0;
      right:0
    }
    .IndexApp .row-a3 .m-slider1 .slide-nav .slick-list ul{
      width:100%
    }
    .IndexApp .row-a3 .m-slider1 .slide-nav .slick-list ul li{
      width:12.5%;
      margin:0;
      height:45px
    }
    .IndexApp .row-a3 .m-slider1 .slide-nav .slick-list ul li.on{
      height:45px

    }
    .IndexApp .row-a3 .m-slider1 .slide-nav .slick-list ul li .tit{
      left:50%;
      top:50%;
      width:70%;
      transform: translate(-50%,-50%);
      padding-bottom:0
    }
    .IndexApp .row-a3 .m-slider1 .slide-nav .slick-list ul li .tit h3{
      font-size:14px;
      text-align:center
    }
    .IndexApp .row-a3 .m-slider1 .slide-nav .slick-list ul li .tit::after{
      background:none;
      height:0
    }

    .IndexApp .row-a4 .newLeft{
      width:100%;
      height:50vw
    }
    .IndexApp .row-a4 .newLeft img{
      height:50vw
    }
    .IndexApp .row-a4 .newLeft .txt h3{
      font-size:15px;
      margin-bottom:8px
    }
    .IndexApp .row-a4 .newLeft .txt  p{
      -webkit-line-clamp: 1;
      font-size:12px;
      margin-bottom:0
    }
    .IndexApp .row-a4 .newRight{
      width:100%;
      height:auto
    }
    .IndexApp .us .uscon{
      padding:0 15px 15px 15px
    }
    .IndexApp .us .uscon img{
      width:20%;
      margin:12px 12px 0 0
    }
    .IndexApp .us .uscon .usright{
      float:none;
      width:100%;
      display:block;
      margin:0 auto;
    }
    .IndexApp .us .uscon .usright h2{
      margin-bottom:5px;
      font-size:18px;
      padding-top:12px
    }
    .IndexApp .us .uscon .usright p{
      line-height:26px
    }
    .IndexApp .us .uscon .usright a{
      padding-top:15px
    }
  }
  @keyframes downico3{
    0%{
      -webkit-transform: translateY(0%);
      -moz-transform: translateY(0%);
      -o-transform: translateY(0%);
      -ms-transform: translateY(0%);
      transform: translateY(0%);
    }
    50%{
      -webkit-transform: translateY(30%);
      -moz-transform: translateY(30%);
      -o-transform: translateY(30%);
      -ms-transform: translateY(30%);
      transform: translateY(30%);
    }
    100%{
      -webkit-transform: translateY(0%);
      -moz-transform: translateY(0%);
      -o-transform: translateY(0%);
      -ms-transform: translateY(0%);
      transform: translateY(0%);
    }
  }
  @keyframes productAM1{
    0% {
        right: 260px;  /* 初始状态 */
    }
    100% {
        right: -32%;  /* 动画结束状态 */
    }
  }
  @keyframes productAM2{
    0% {
        right: -32%;  /* 初始状态 */
    }
    100% {
        right: 260px;  /* 动画结束状态 */
    }
  }
  .vjs-control-bar{
    display: none !important;
  }
  .IndexApp .video-js .vjs-big-play-button {
    display:none;
  }
</style>